import React, { useEffect, useState, useCallback } from "react";
import { Layout, Model } from "flexlayout-react";
import "flexlayout-react/style/light.css";
import FloorplanPopup from "pages/components/floorplan";
import TenantService from "api/tenant.service";
import AssetsService from "api/assets.service";
import TreeView from "devextreme-react/tree-view";
import { Tooltip } from "devextreme-react";
import AssetViewMultiple from "../assetMultiple";
import DataGrid, {
  Column,
  Paging,
  FilterRow,
  HeaderFilter,
  Selection,
  FilterPanel
} from 'devextreme-react/data-grid';
import SelectBox from "devextreme-react/select-box";
import Chart, {
  ArgumentAxis,
  CommonSeriesSettings,
  Series,
  ValueAxis,
  Legend,
  Label,
  Tick,
  Title,
  Size,
  Tooltip as DxTooltip
} from "devextreme-react/chart";
import TreeList, {
  Column as TreeListColumn,
  SearchPanel,
  Selection as TreeListSelection
} from "devextreme-react/tree-list";
import AnalyzeInfoTab from "./analyzeLayout/infoPanel/InfoPanel"
// import AnalyzeInfoTab from "./analyzeLayout/InfoTab";
import AnalyzeSpaceTab from "./analyzeLayout/spacesPanel/SpacesPanel";
// import AnalyzeSpaceTab from "./analyzeLayout/AnalyzeSpaceTab";
import SelectionTree from "./analyzeLayout/selectionPanel/SelectionPanel";
// import SelectionTree from "./analyzeLayout/SelectionTree";


const dataSource = [
  { asset: "Asset 1", date: new Date("2024-11-17T00:00"), noMotion: 50, motion: 10 },
  { asset: "Asset 2", date: new Date("2024-11-17T00:00"), noMotion: 60, motion: 5 },
  { asset: "Asset 3", date: new Date("2024-11-17T00:00"), noMotion: 40, motion: 15 }
];

const analyzeTabData = {
        "treeListData": [
            {
                "name": "State A",
                "total_dwell_time": 456,
                "count": 83,
                "total_time_diff": 28472,
                "id": "42e5437a-1e9d-488d-a5b2-45a380256c78",
                "avg": 343
            },
            {
                "name": "State B",
                "total_dwell_time": 504,
                "count": 88,
                "total_time_diff": 30240,
                "id": "d97451fc-b77a-4e20-a36e-4e8da0b7b043",
                "avg": 344
            },
            {
                "name": "State C",
                "total_dwell_time": 544,
                "count": 88,
                "total_time_diff": 30148,
                "id": "89cd2d91-4c98-4981-8cc9-6af0b069a884",
                "avg": 343
            },
            {
                "name": "State D",
                "total_dwell_time": 428,
                "count": 75,
                "total_time_diff": 25728,
                "id": "b00d6d00-c0cb-478a-a2f8-963492a03408",
                "avg": 343
            }
        ],
        "rawData": [
            {
                "dwell_time": 10,
                "name": "State A",
                "process_state_dwell_start": "2024-09-29T20:21:20.137Z",
                "process_time": 339
            },
            {
                "dwell_time": 10,
                "name": "State B",
                "process_state_dwell_start": "2024-09-26T20:21:03.648Z",
                "process_time": 342
            },
            {
                "dwell_time": 8,
                "name": "State C",
                "process_state_dwell_start": "2024-09-26T20:21:01.180Z",
                "process_time": 342
            },
            {
                "dwell_time": 6,
                "name": "State A",
                "process_state_dwell_start": "2024-09-21T20:21:07.310Z",
                "process_time": 347
            },
            {
                "dwell_time": 1,
                "name": "State A",
                "process_state_dwell_start": "2024-09-23T20:21:07.383Z",
                "process_time": 345
            },
            {
                "dwell_time": 10,
                "name": "State A",
                "process_state_dwell_start": "2024-09-21T20:21:06.631Z",
                "process_time": 347
            },
            {
                "dwell_time": 10,
                "name": "State C",
                "process_state_dwell_start": "2024-09-22T20:21:06.932Z",
                "process_time": 346
            },
            {
                "dwell_time": 1,
                "name": "State C",
                "process_state_dwell_start": "2024-09-22T20:21:07.163Z",
                "process_time": 346
            },
            {
                "dwell_time": 6,
                "name": "State D",
                "process_state_dwell_start": "2024-09-30T20:21:01.632Z",
                "process_time": 338
            },
            {
                "dwell_time": 9,
                "name": "State C",
                "process_state_dwell_start": "2024-09-30T20:21:08.966Z",
                "process_time": 338
            },
            {
                "dwell_time": 1,
                "name": "State D",
                "process_state_dwell_start": "2024-09-22T20:21:08.739Z",
                "process_time": 346
            },
            {
                "dwell_time": 9,
                "name": "State A",
                "process_state_dwell_start": "2024-09-23T20:21:08.585Z",
                "process_time": 345
            },
            {
                "dwell_time": 6,
                "name": "State D",
                "process_state_dwell_start": "2024-09-21T20:21:08.659Z",
                "process_time": 347
            },
            {
                "dwell_time": 2,
                "name": "State C",
                "process_state_dwell_start": "2024-09-25T20:21:23.888Z",
                "process_time": 343
            },
            {
                "dwell_time": 9,
                "name": "State B",
                "process_state_dwell_start": "2024-09-23T20:21:06.405Z",
                "process_time": 345
            },
            {
                "dwell_time": 2,
                "name": "State D",
                "process_state_dwell_start": "2024-09-23T20:21:11.224Z",
                "process_time": 345
            },
            {
                "dwell_time": 8,
                "name": "State A",
                "process_state_dwell_start": "2024-09-25T20:21:12.783Z",
                "process_time": 343
            },
            {
                "dwell_time": 10,
                "name": "State A",
                "process_state_dwell_start": "2024-09-21T20:21:13.606Z",
                "process_time": 347
            },
            {
                "dwell_time": 9,
                "name": "State A",
                "process_state_dwell_start": "2024-09-23T20:21:15.854Z",
                "process_time": 345
            },
            {
                "dwell_time": 8,
                "name": "State A",
                "process_state_dwell_start": "2024-09-21T20:21:16.078Z",
                "process_time": 347
            },
            {
                "dwell_time": 5,
                "name": "State B",
                "process_state_dwell_start": "2024-09-22T20:21:16.529Z",
                "process_time": 346
            },
            {
                "dwell_time": 8,
                "name": "State B",
                "process_state_dwell_start": "2024-09-26T20:21:00.498Z",
                "process_time": 342
            },
            {
                "dwell_time": 8,
                "name": "State A",
                "process_state_dwell_start": "2024-09-26T20:21:01.026Z",
                "process_time": 342
            },
            {
                "dwell_time": 1,
                "name": "State C",
                "process_state_dwell_start": "2024-09-29T20:21:01.407Z",
                "process_time": 339
            }
        ]
    }

const mockData = [
  {
      "id": "38c809f9-b0f0-4967-828d-d77020e1ce80",
      "time": "2025-08-29T20:03:23.217Z",
      "isFloorplan": true,
      "motion": "Stationary Update",
      "duration": "22 hours 26 minutes",
      "level": null,
      "space": {
          "id": "3045ce9e-d9ec-4eaa-9711-0c1ccc05027e",
          "name": "DM Hr Test",
          "localCoordinates": {
              "x": 5.130076110963277,
              "y": 15.417168360566738
          },
          "geoCoordinates": null
      },
      "distance": 0
  },
  {
      "id": "94c4d2f8-4382-4d9d-8f2a-17f61ef19f54",
      "time": "2025-08-29T20:02:27.668Z",
      "isFloorplan": true,
      "motion": "Stationary Update",
      "duration": 0,
      "level": null,
      "space": {
          "id": "85727ab9-3576-40bb-9f2d-f13f13ab7765",
          "name": "Test 120725",
          "localCoordinates": {
              "x": 13.53007611096326,
              "y": 29.617168360566687
          },
          "geoCoordinates": null
      },
      "distance": 0
  },
  {
      "id": "7a389939-b7c3-47e0-9097-1cda54d13ea8",
      "time": "2025-08-29T20:01:27.800Z",
      "isFloorplan": true,
      "motion": "Stationary Update",
      "duration": null,
      "level": null,
      "space": {
          "id": "3045ce9e-d9ec-4eaa-9711-0c1ccc05027e",
          "name": "DM Hr Test",
          "localCoordinates": {
              "x": 37.53007611096327,
              "y": 25.8171683605667
          },
          "geoCoordinates": null
      },
      "distance": 0
  },
  {
      "id": "9f4c0e60-dc83-4a25-ab93-e2e62311e845",
      "time": "2025-08-29T20:00:23.232Z",
      "isFloorplan": true,
      "motion": "Stationary Update",
      "duration": 0,
      "level": null,
      "space": {
          "id": "3045ce9e-d9ec-4eaa-9711-0c1ccc05027e",
          "name": "DM Hr Test",
          "localCoordinates": {
              "x": 4.86340944429661,
              "y": 15.283835027233403
          },
          "geoCoordinates": null
      },
      "distance": 0
  },
  {
      "id": "b9a8ff6d-2e40-4585-9e04-3f6549040e75",
      "time": "2025-08-29T19:57:19.593Z",
      "isFloorplan": true,
      "motion": "Stationary Update",
      "duration": null,
      "level": null,
      "space": {
          "id": "3045ce9e-d9ec-4eaa-9711-0c1ccc05027e",
          "name": "DM Hr Test",
          "localCoordinates": {
              "x": 33.73007611096322,
              "y": 9.417168360566759
          },
          "geoCoordinates": null
      },
      "distance": 0
  },
  {
      "id": "b18ff3b4-49c4-4790-9060-3cc2f6eba3f0",
      "time": "2025-08-29T19:56:27.819Z",
      "isFloorplan": true,
      "motion": "Stationary Update",
      "duration": 0,
      "level": null,
      "space": {
          "id": "3045ce9e-d9ec-4eaa-9711-0c1ccc05027e",
          "name": "DM Hr Test",
          "localCoordinates": {
              "x": 37.53007611096327,
              "y": 26.2171683605667
          },
          "geoCoordinates": null
      },
      "distance": 0
  },
  {
      "id": "fa246f0f-a77a-4f8a-9f6d-084024a9eb7f",
      "time": "2025-08-29T19:55:27.826Z",
      "isFloorplan": true,
      "motion": "Stationary Update",
      "duration": null,
      "level": null,
      "space": {
          "id": "3045ce9e-d9ec-4eaa-9711-0c1ccc05027e",
          "name": "DM Hr Test",
          "localCoordinates": {
              "x": 37.53007611096327,
              "y": 25.8171683605667
          },
          "geoCoordinates": null
      },
      "distance": 0
  },
  {
      "id": "6533b432-f87b-450a-8d23-85037be43474",
      "time": "2025-08-29T19:54:27.711Z",
      "isFloorplan": true,
      "motion": "Stationary Update",
      "duration": 0,
      "level": null,
      "space": {
          "id": "85727ab9-3576-40bb-9f2d-f13f13ab7765",
          "name": "Test 120725",
          "localCoordinates": {
              "x": 12.730076110963262,
              "y": 30.017168360566686
          },
          "geoCoordinates": null
      },
      "distance": 0
  }
        
];


// const SelectionTree = (props) => {
//   const [assetList] = useState(props?.assets || []);
  
//   // Initialize all assets as selected by default
//   const [selectedAssets, setSelectedAssets] = useState(() => {
//     const initial = {};
//     assetList.forEach((asset, index) => {
//       initial[`asset-${index + 1}`] = true;
//     });
//     return initial;
//   });
//   const [selectedPeriod, setSelectedPeriod] = useState(null);

//   const handleAssetCheck = (id, checked) => {
//     setSelectedAssets((prev) => ({
//       ...prev,
//       [id]: checked
//     }));
//   };

//   const handleValueChange = async (value) => {
//     // your big switch/case logic from before
//   };

//   const handlePeriodCheck = (value) => {
//     setSelectedPeriod(value);
//     handleValueChange(value); // reuse your existing logic
//   };

//   const [items] = useState([
//     {
//       id: 1,
//       text: "Assets",
//       expanded: true,
//       items: assetList.map((asset, index) => ({
//         id: `asset-${index + 1}`,
//         text: asset?.name || asset,
//         isCheckable: true,
//         type: "asset"
//       }))
//     },
//     {
//       id: 2,
//       text: "Period",
//       expanded: true,
//       items: [
//         { id: "Today", text: "Today", isCheckable: true, type: "period" },
//         { id: "Last 5 min", text: "Last 5 min", isCheckable: true, type: "period" },
//         { id: "Last 20 min", text: "Last 20 min", isCheckable: true, type: "period" },
//         { id: "Last 1 hour", text: "Last 1 hour", isCheckable: true, type: "period" },
//         { id: "Last 4 hour", text: "Last 4 hour", isCheckable: true, type: "period" },
//         { id: "Last 12 hour", text: "Last 12 hour", isCheckable: true, type: "period" },
//         { id: "Last 24 hour", text: "Last 24 hour", isCheckable: true, type: "period" },
//         { id: "Yesterday", text: "Yesterday", isCheckable: true, type: "period" },
//         { id: "This Week", text: "This Week", isCheckable: true, type: "period" },
//         { id: "This Month", text: "This Month", isCheckable: true, type: "period" },
//         { id: "Last Month", text: "Last Month", isCheckable: true, type: "period" },
//         { id: "Last 7 days", text: "Last 7 days", isCheckable: true, type: "period" },
//         { id: "Custom", text: "Custom", isCheckable: true, type: "period" },
//       ]
//     }
//   ]);

//   const renderItem = (item) => {
//     if (item.isCheckable) {
//       if (item.type === "period") {
//         return (
//           <label style={{ cursor: "pointer" }}>
//             <input
//               type="checkbox"
//               checked={selectedPeriod === item.id}
//               onChange={() => handlePeriodCheck(item.id)}
//               style={{ marginRight: "6px" }}
//             />
//             {item.text}
//           </label>
//         );
//       }

//       if (item.type === "asset") {
//         return (
//           <label style={{ cursor: "pointer" }}>
//             <input
//               type="checkbox"
//               checked={!!selectedAssets[item.id]}
//               onChange={(e) => handleAssetCheck(item.id, e.target.checked)}
//               style={{ marginRight: "6px" }}
//             />
//             {item.text}
//           </label>
//         );
//       }
//     }

//     if (item.isLink) {
//       return (
//         <a
//           href="#"
//           style={{ color: "#007bff", textDecoration: "underline" }}
//           onClick={(e) => e.preventDefault()}
//         >
//           {item.text}
//         </a>
//       );
//     }

//     return <span>{item.text}</span>;
//   };

//   return (
//     <div style={{ width: "100%", height: "100%", overflow: "auto" }}>
//       <TreeView
//         items={items}
//         expandNodesRecursive={true}
//         width="100%"
//         itemRender={renderItem}
//       />





//       <SlidingDrawer
//       // title="Add Asset"
//       title={`${formData?.id ? "Edit" : "Add"} Asset`}
//       isOpen={isOpen}
//       onClose={handleCloseDrawer}
//       handleSave={handleSave}
//       formData={formData}
//       prevData={prevData}
//     >
//       {isOpen &&
//       <form ref={formRef} onSubmit={handleSubmit}>
//         <div>
//           <DxForm
//             formData={formData}
//             onFieldDataChanged={(e) => {
//               setFormData((prev) => ({
//                 ...prev,
//                 [e.dataField]: e.value,
//               }));
//             }}
//             onInitialized={(e) => {
//               dxFormRef.current = e.component;
//             }}
//             labelLocation="top"
//             showColonAfterLabel={false}
//             showValidationSummary={false}
//           >
//             <GroupItem colCount={1}>
//               <SimpleItem
//                 dataField="name"
//                 editorType="dxTextBox"
//                 editorOptions={{
//                   valueChangeEvent: 'input',
//                 }}
//                 validationRules={[{ type: 'required', message: 'Name is required' }]}
//               >
//                 <Label text="Name" isRequired />
//               </SimpleItem>

//               <SimpleItem
//                 dataField="type"
//                 editorType="dxSelectBox"
//                 editorOptions={{
//                   items: positionEditorOptions?.items || [],
//                   displayExpr: 'name',
//                   valueExpr: 'id',
//                   placeholder: 'Select...',
//                   searchEnabled: true,
//                   dropDownOptions: {
//                     container: '.slide-pane'
//                   },
//                   itemRender: (item) => (
//                     <div className="custom-item">
//                       <div className="product-name">{item.name}</div>
//                     </div>
//                   ),
//                 }}
//                 validationRules={[{ type: 'required', message: 'Asset Type is required' }]}
//               >
//                 <Label text="Asset Type" isRequired />
//               </SimpleItem>

//               <SimpleItem
//                 dataField="pairedDevice"
//                 editorType="dxSelectBox"
//                 editorOptions={{
//                   items: deviceEditorOptions?.dataSource || [],
//                   displayExpr: 'serialNumber',
//                   valueExpr: 'id',
//                   placeholder: 'Select a device',
//                   // showClearButton: true,
//                   searchEnabled: true,
//                   dropDownOptions: {
//                     container: '.slide-pane'
//                   }
//                 }}
//                 validationRules={[{ type: 'required', message: 'Paired Device is required' }]}
//               >
//                 <Label text="Paired Device" isRequired />
//               </SimpleItem>
//             </GroupItem>
//           </DxForm>
//         </div>
//       </form>
//       }
//     </SlidingDrawer>
//     </div>
//   );
// };

const AnalyzeTab = () => {
  // State variables for the analyze tab
  const [selectedStates, setSelectedStates] = useState('process_state');
  const [selectedAttributes, setSelectedAttributes] = useState('dwell_time');
  const [histogramData, setHistogramData] = useState([]);
  const [rawData, setRawData] = useState([]);
  const [selectedProcessState, setSelectedProcessState] = useState('State A'); // Set default selected state
  const [dataTree, setTreeData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [dynamicCaption, setDynamicCaption] = useState('Process State');
  const [dynamicCaption3, setDynamicCaption3] = useState('Dwell Time (Avg Days)');

  // Groups and attributes configuration
  const groups = [{"id":"process_state", "name":"Process State"},{"id":"space", "name":"Space"}];
  const attributes = [{id:'dwell_time', name: 'Dwell Time'}];

  // Calculate histogram data function
  const calculateHistogramData = (data) => {
    if (!data || data.length === 0) {
      return [];
    }
  
    // Extract process_time values, filtering out invalid ones
    const processTimes = data.map(item => item.process_time).filter(pt => pt !== null && pt !== undefined);
  
    if (processTimes.length === 0) {
      return []; // Handle case where all process_time values are null or undefined
    }
  
    // Calculate min and max values for process_time
    const max_data_value = Math.max(...processTimes);
    const min_data_value = Math.min(...processTimes);
  
    // Define bin configuration
    const num_bins = 10; // Fixed number of bins
    const bin_width = Math.ceil((max_data_value - min_data_value) / num_bins) || 1; // Avoid division by zero
  
    // Create bins
    const bins = Array.from({ length: num_bins }, (_, i) => ({
      range: min_data_value + i * bin_width,
      count: 0,
    }));
  
    // Assign each process_time to the appropriate bin
    processTimes.forEach((process_time) => {
      for (let i = 0; i < bins.length; i++) {
        if (i === bins.length - 1 || process_time < bins[i + 1].range) {
          bins[i].count++;
          break;
        }
      }
    });
  
    // Fill empty bins with zero count up to the max range
    const filledBins = bins.map(bin => ({
      range: bin.range.toString(), // Convert range to string
      count: bin.count,
    }));
  
    return filledBins;
  };

  // Initialize data from analyzeTabData
  useEffect(() => {
    setTreeData(analyzeTabData.treeListData);
    setRawData(analyzeTabData.rawData);
    
    // Initialize histogram data with State A data
    const initialStateData = analyzeTabData.rawData.filter(item => item.name === 'State A');
    if (initialStateData.length > 0) {
      const initialHistogram = calculateHistogramData(initialStateData);
      setHistogramData(initialHistogram);
    }
  }, []);

  // Update dynamic captions based on selections
  useEffect(() => {
    if (selectedStates) {
      const caption = groups.find(item => item.id === selectedStates);
      setDynamicCaption(caption ? caption.name : 'Select a Column'); 
      const caption3 = attributes.find(item => item.id === selectedAttributes);
      setDynamicCaption3(caption3 ? caption3.name && caption3.name === "Dwell Time" ? "Dwell Time (Avg Days)" : caption3.name : 'Select a Column'); 
    } else {
      setDynamicCaption('Select a Column');
      setDynamicCaption3('Select a Column');
    }
  }, [selectedStates, selectedAttributes]);

  // Handle state change
  const handleStateChange = (e) => {
    console.log('value of selected states: ', e.value);
    setSelectedStates(e.value);
  };

  // Handle attribute change
  const handleAttributeChange = (e) => {
    console.log('value of selected attributes: ', e.value);
    setSelectedAttributes(e.value);
  };

  // Handle selection change in TreeList
  const handleSelectionChanged = (e) => {
    // Check if selectedRowsData array exists and has at least one element
    if (e.selectedRowsData && e.selectedRowsData.length > 0) {
      const selectedState = e.selectedRowsData[0].name;
      
      // Check if selectedState is not undefined or null
      if (selectedState != null) {
        setSelectedProcessState(selectedState);
        
        // Filter rawData based on selected name
        const filteredData = analyzeTabData.rawData.filter(item => item.name === selectedState);
        
        console.log('filteredData: ', filteredData);
        
        // Update selectedRowKeys
        setSelectedRowKeys(e.selectedRowKeys);
        
        // Check if filteredData has elements before calculating histogram
        if (filteredData.length > 0) {
          const histogram = calculateHistogramData(filteredData);
          setHistogramData(histogram);
        } else {
          setHistogramData([]);
        }
      } else {
        console.warn('Selected row does not have a name property');
        setHistogramData([]);
      }
    } else {
      console.warn('No row selected');
      setSelectedProcessState(null);
      setSelectedRowKeys([]);
      setHistogramData([]);
    }
  };

  // Customize tooltip for chart
  const customizeEventsLabel = (arg) => {
    return {
      text: `${arg.valueText}`,
    };
  };

  return (
    <div style={{ padding: "10px" }}>
      {/* Selection controls */}
      
      {/* <div style={{ marginBottom: "20px", display: "flex", gap: "20px" }}>
        <div style={{ width: "250px" }}>
          <SelectBox
            style={{ width: '100%' }}
            value={selectedStates}
            onValueChanged={handleStateChange}
            dataSource={groups}
            labelMode="static"
            label="Grouping"
            stylingMode="outlined"
            valueExpr="id"
            displayExpr="name"
          />
        </div>
        <div style={{ width: "250px" }}>
          <SelectBox
            style={{ width: '100%' }}
            value={selectedAttributes}
            onValueChanged={handleAttributeChange}
            dataSource={attributes}
            labelMode="static"
            label="Attribute Analyzed"
            stylingMode="outlined"
            valueExpr="id"
            displayExpr="name"
          />
        </div>
      </div> */}

      {/* TreeList */}
      {selectedAttributes && selectedStates ? (
        <TreeList
          dataSource={dataTree}
          idField="name"
          defaultExpandedRowKeys={[]}
          showRowLines={true}
          showBorders={true}
          className='analyze-treelist'
          scrolling={{ mode: 'standard', showScrollbar: 'always' }}
          // height={'calc(100vh - 400px)'}
          height={'200px'}
          selectedRowKeys={selectedRowKeys}
          onSelectionChanged={handleSelectionChanged}
          style={{ marginBottom: "20px" }}
        >
          <TreeListColumn 
            dataField="name" 
            caption={dynamicCaption || 'Select a Column'} 
          />
          <TreeListColumn dataField="count" caption="Asset Count" alignment="center" />
          <TreeListColumn 
            dataField="avg" 
            alignment="center" 
            caption={dynamicCaption3} 
          />
          <SearchPanel visible={false} />
          <TreeListSelection mode="single" />
        </TreeList>
      ) : ""}

      {/* Chart - Always visible with static data */}
      <div style={{ width: "100%", marginTop: "20px" }}>
        <h5 style={{ textAlign: "center", fontSize: "14px", marginBottom: "20px" }}>
          Asset Count by Dwell Time For {selectedProcessState}
        </h5>
        <Chart
          dataSource={histogramData}
          idField="process_state"
          width={'100%'}
          legend={{ visible: false }}
          style={{"--height": "500px"}}
          animation={{"enabled": false}} 
        >
          <CommonSeriesSettings
            argumentField="range"
          />
          <DxTooltip
            enabled={true}
            horizontalAlignment="left"
            customizeTooltip={customizeEventsLabel}
          />
          <Size
            width={'100%'}
            height={250}
          />
          <Series
            argumentField="range"
            valueField="count"
            name=""
            type="bar"
            color="#FFC001"
          />
          <ArgumentAxis 
            visible={true} 
            discreteAxisDivisionMode="crossLabels"
            type="discrete"
            label={{
              overlappingBehavior: 'none',
              alignment: 'center',
            }}
          >
            <Label overlappingBehavior="none" alignment="center">
              {item => {
                return `${item.value}`;
              }}
            </Label>
            <Tick visible={true} />
            <Title text="Dwell Time (Avg Days)"></Title>
          </ArgumentAxis>
          <ValueAxis
            visible={true}
            tickInterval={1}
            min={0}
            max={histogramData.length > 0 ? Math.max(...histogramData.map(item => item.count)) + 1 : 10}
          >
            <Label />
            <Title text="Asset Count" />
          </ValueAxis>
        </Chart>
      </div>
    </div>
  );
};


const TelemetryTab = () => {
  return (
    <div style={{ padding: "10px" }}>
      <Chart
      dataSource={dataSource}
      rotated={true} // Horizontal bars
    >
      {/* X-Axis: Time */}
      <ArgumentAxis argumentType="datetime" />

      {/* Y-Axis: Assets */}
      <ValueAxis />

      {/* No Motion series */}
      <Series
        valueField="noMotion"
        argumentField="date"
        name="No Motion"
        type="stackedBar"
        color="#B0B0B0"
      />

      {/* Motion series */}
      <Series
        valueField="motion"
        argumentField="date"
        name="Motion"
        type="stackedBar"
        color="#FFD54F"
      />

      <Legend verticalAlignment="bottom" horizontalAlignment="center" />
      <Tooltip enabled={true} />
    </Chart>
    </div>
  )
}

const DataTab = () => {

  const tenant = TenantService.getTenant();
    const [parsedSelectedAssets, setParsedSelectedAssets] = useState([]);

    useEffect(() => {
      let selectedAssets = localStorage.getItem(`multiple-asset-selection-records-${tenant}`)
      let parsedSelectedAssets = JSON.parse(selectedAssets);
      setParsedSelectedAssets(parsedSelectedAssets || []);
    }, []);
    
  return (
    <div style={{ padding: "10px" }}>
      <DataGrid
        id="gridContainer"
        // dataSource={dataSource}
        dataSource={parsedSelectedAssets}
        keyExpr="id"
        noDataText="No records available"
        showColumnLines={false}
        showRowLines={true}
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnResizingMode="nextColumn"
        columnMinWidth={80}
        columnAutoWidth={true}
        // height={heightOfGrid}
      >
        {/* Virtual scrolling for performance */}
        {/* <Scrolling mode="virtual" useNative={true} /> */}

        {/* No loading panel */}
        {/* <LoadPanel enabled={false} /> */}

        {/* Filters */}
        <FilterRow visible={true} applyFilter="auto" />
        <HeaderFilter visible={true} />
        <SearchPanel visible={true} width={240} placeholder="Search..." />

        {/* Pagination */}
        <Paging enabled={true} />

        {/* Export option */}
        {/* <Export enabled={true} /> */}

        {/* Example columns */}
        <Column dataField="name" caption="Name" dataType="string" width={190} />
        <Column dataField="type.name" caption="Type" dataType="string" />
        <Column dataField="event" caption="Latest Event" dataType="string" visible={false}/>
        <Column
          dataField="motionDistance"
          caption="Distance Travelled[m] (Last 7 days)"
          dataType="number"
          visible={false}
        />
        <Column
          dataField="motionDuration"
          caption="Motion Duration (Last 7 days)"
          dataType="string"
          visible={false}
        />
        <Column dataField="status" caption="Status" dataType="string" visible={false} />
        <Column dataField="lastKnownLocation.name" caption="Space" dataType="string" />
        <Column
          dataField="lastKnownLocation.timestamp"
          caption="Location Update Time"
          dataType="datetime"
          format="EEE MMM dd yyyy, hh:mm a"
        />
        <Column dataField="processState" caption="Process State" dataType="string" visible={false} />
      </DataGrid>
    </div>
  )
}

const InfoTab = () => {
  const tenant = TenantService.getTenant();
  const [data, setData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [focusedRowKey, setFocusedRowKey] = useState(null);
  const [loadingText, setLoadingText] = useState('Loading...');

  useEffect(() => {
    let mounted = true;

    const fetchLocationHistoryMultiple = async () => {
      try {
        // Try assetMultiple stored ids/records first
        const idsStored = localStorage.getItem(`multiple-asset-selection-ids-${tenant}`);
        const recordsStored = localStorage.getItem(`multiple-asset-selection-records-${tenant}`);
        const ids = idsStored ? JSON.parse(idsStored) : null;
        const records = recordsStored ? JSON.parse(recordsStored) : null;

        // If service is available call locationHistoryMultiple, otherwise fallback to stored records
        if (AssetsService && typeof AssetsService.locationHistoryMultiple === "function") {
          // Pass ids if available, otherwise try passing records (service implementations vary)
          const payload = ids && ids.length ? ids : records || [];
          if (!payload || payload.length === 0) {
            if (mounted) {
              setData(records || []);
              setLoadingText((records && records.length) ? '' : 'No Data');
            }
            return;
          }

          const resp = await AssetsService.locationHistoryMultiple(payload);
          const result = resp?.data ?? resp ?? [];
          if (mounted) {
            setData(result);
            setLoadingText((result && result.length) ? '' : 'No Data');
          }
        } else {
          // Fallback to localStorage copy used by assetMultiple
          if (mounted) {
            setData(records || []);
            setLoadingText((records && records.length) ? '' : 'No Data');
          }
        }
      } catch (err) {
        console.error("InfoTab: failed to load locationHistoryMultiple", err);
        if (mounted) setLoadingText('No Data');
      }
    };

    fetchLocationHistoryMultiple();
    return () => { mounted = false; };
  }, [tenant]);

  const onSelectionChanged = useCallback(({ selectedRowKeys: changedRowKeys }) => {
    setSelectedRowKeys(changedRowKeys);
  }, []);

  const handleCellHoverChanged = useCallback((e) => {
    // mirror behavior from assetMultiple if needed
  }, []);

  return (
    <div style={{ padding: "10px" }}>

      <AnalyzeInfoTab 
        assetName={"pageName"}
        onSpaceLoad={(spaces)=> {}}
        onDateChange={(dateRange)=> {}}
      />

      {/* <AssetViewMultiple
        // assetId={assetId}
        assetName={"pageName"}
        // onSpaceLoad={(spaces)=>setSpaces(spaces)}
        // onDateChange={(dateRange)=>setDateRange(dateRange)}
        onSpaceLoad={(spaces)=> {}}
        onDateChange={(dateRange)=> {}}
        // dateRange={dateRange}
        // selectedTabIndex={selectedTabIndex}
        // dwellTime={(dTime)=>setLatestDwellTime(dTime)}
        // dwellTime={handleDwellTime}
      /> */}


      {/* <DataGrid
        height="calc(100vh - 400px)"
        keyExpr="id"
        dataSource={data}
        columnAutoWidth={true}
        allowColumnResizing={true}
        showBorders={true}
        focusedRowKey={focusedRowKey}
        selectedRowKeys={selectedRowKeys}
        onSelectionChanged={onSelectionChanged}
        noDataText={loadingText}
        onCellHoverChanged={handleCellHoverChanged}
        scrolling={{ mode: 'standard', showScrollbar: 'always' }}
        repaintChangesOnly={true}
        focusedRowEnabled={true}
        autoNavigateToFocusedRow={false}
      >
        <Selection mode="multiple" showCheckBoxesMode="none" />
        <FilterPanel visible={true} texts={{ createFilter: '', clearFilter: 'Clear Filter', filterEnabledHint: '' }} />
        <Paging enabled={false} />
        <FilterRow visible={true} applyFilter="auto" />
        <HeaderFilter visible={true} />

        <Column
          allowSorting={true}
          dataField="time"
          caption={'Date'}
          dataType="datetime"
          format="yyyy-MM-dd HH:mm:ss"
          allowFiltering={false}
          defaultSortIndex={1}
          defaultSortOrder="desc"
          fixed={true}
          hidingPriority={8}
        />
        <Column dataField="asset" caption={'Asset'} fixed={true} />
        <Column dataField="space.name" caption={'Space'} fixed={true} />
        <Column dataField="motion" caption={'Event'} fixed={true} width={"40%"} alignment="left" />
        <Column dataField="distance" caption={'Distance [m]'} fixed={true} alignment="left" />
      </DataGrid> */}
    </div>
  )
}


export default function AssetsAnalyze() {
    const tenant = TenantService.getTenant();
    const [parsedSelectedAssets, setParsedSelectedAssets] = useState([]);
    const [isAssetEdit, setIsAssetEdit] = useState(false);

     const [selectedAssetsData, setSelectedAssetsData] = useState({});

    useEffect(() => {
      let selectedAssets = localStorage.getItem(`multiple-asset-selection-records-${tenant}`)
      let parsedSelectedAssets = JSON.parse(selectedAssets);
      setParsedSelectedAssets(parsedSelectedAssets || []);
    }, []);

    useEffect(() => {
      // Reset isAssetEdit when component mounts or parsedSelectedAssets change
      const initial = {};
      parsedSelectedAssets.forEach((asset, index) => {
        // initial[`asset-${index + 1}`] = true;
        initial[`${asset?.id}`] = true;
      });
      setSelectedAssetsData(initial);
    }, [parsedSelectedAssets]);

    const ICON_STRIP_WIDTH = 56;
  
    const json = {
      global: {
        tabEnableClose: false, // globally disable close
        tabEnableRename: false
      },
      layout: {
        type: "row",
        children: [
          // LEFT PANE (Selection)
          {
            type: "tabset",
            id: "leftSelection",
            weight: 20,
            minSize: 70,
            enableCollapse: true,
            collapsedSize: 70,
            enableDrag: false,
            enableDrop: false,
            children: [
              {
                type: "tab",
                name: "Selection",
                component: "selection",
                enableDrag: false,
                enableClose: false
              }
            ]
          },
          // MIDDLE COLUMN
          {
            type: "column",
            id: "middleColumn",
            weight: 40,
            children: [
              {
                type: "tabset",
                id: "topMiddle",
                weight: 40,
                minSize: 70,
                enableCollapse: true,
                collapsedSize: 70,
                children: [
                  {
                    type: "tab",
                    name: "Telemetry",
                    component: "telemetry",
                    enableClose: false
                  }
                ]
              },
              {
                type: "tabset",
                id: "bottomMiddle",
                weight: 40,
                minSize: 70,
                enableCollapse: true,
                collapsedSize: 70,
                children: [
                  {
                    type: "tab",
                    name: "Analyze",
                    component: "analyze",
                    enableClose: false
                  }
                ]
              }
            ]
          },
          // RIGHT COLUMN
          {
            type: "column",
            id: "rightColumn",
            weight: 40,
            children: [
              {
                type: "tabset",
                id: "topRight",
                weight: 40,
                minSize: 70,
                enableCollapse: true,
                collapsedSize: 70,
                children: [
                  {
                    type: "tab",
                    name: "Spaces",
                    component: "spaces",
                    enableClose: false
                  }
                ]
              },
              {
                type: "tabset",
                id: "bottomRight",
                weight: 40,
                minSize: 70,
                enableCollapse: true,
                collapsedSize: 70,
                children: [
                  {
                    type: "tab",
                    name: "Info",
                    component: "panel4",
                    enableClose: false
                  },
                  {
                    type: "tab",
                    name: "Data",
                    component: "panel5",
                    enableClose: false
                  }
                ]
              }
            ]
          }
        ]
      }
    };
  
    const model = Model.fromJson(json);
  
    const factory = (node) => {
      const c = node.getComponent();
      // if (c === "selection") return <div>Selection Tree Here</div>;
      if (c === "selection") return <SelectionTree setIsAssetEdit={setIsAssetEdit} assets={parsedSelectedAssets} isAssetEdit={isAssetEdit} setSelectedAssetsData={setSelectedAssetsData} selectedAssetsData={selectedAssetsData} />;
      if (c === "telemetry") return <TelemetryTab />;
      if (c === "spaces") return (
                <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
                  {/* <FloorplanPopup
                    hoveredCoordinates={null}
                    spaceId={"3045ce9e-d9ec-4eaa-9711-0c1ccc05027e"}
                    myMarkers={[]}
                    type={"polyline"}
                    zoneEditControl={false}
                    highlightRow={null}
                  /> */}

                  <AnalyzeSpaceTab 
                    assetName={"pageName"}
                    onSpaceLoad={(spaces)=> {}}
                    onDateChange={(dateRange)=> {}}
                  />
                </div>
              );
      if (c === "analyze") return <AnalyzeTab />;
      if (c === "panel4") return <InfoTab />;
      if (c === "panel5") return <DataTab />;
      return <div>Unknown</div>;
    };


    const handleIconClick = (title) => {
      switch (title) {
        case "Edit":
          console.log("Edit mode activated");
          setIsAssetEdit(true);

          const trueKeys = Object.keys(selectedAssetsData).filter(key => selectedAssetsData[key] === true);

          if (trueKeys.length === 1) {
            console.log("Only one true:", trueKeys[0]); // the single true key (id)
            // your "if" logic here
            parsedSelectedAssets.find(asset => {
              if (asset.id === trueKeys[0]) {
                console.log("Editing asset:", asset);
                // You can now use the 'asset' object for editing
              }});
          } else {
            console.log("Either none or more than one true");
            // your "else" logic here
          }

          
          break;

        case "Drag/Move":
          console.log("Drag/Move activated");
          break;

        case "Export to CSV":
          console.log("Exporting to CSV...");
          break;

        case "Copy to Clipboard":
          console.log("Copying...");
          break;

        case "Reset Layout":
          console.log("Layout reset");
          break;

        default:
          console.log("Unknown action");
      }
    };

  
    return (
      <div style={{ display: "flex", height: "calc(100vh - 50px)", width: "100vw" }}>
        {/* FIXED ICON STRIP (outside FlexLayout) */}
        <div
          style={{
            width: `${ICON_STRIP_WIDTH}px`,
            background: "#f5f5f5",
            borderRight: "1px solid #ddd",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
            paddingTop: "10px",
            gap: "15px",
            zIndex: 10
          }}
        >
        {[{ icon: "✏️", title: "Edit" }, { icon: "🖐️", title: "Drag/Move" }, 
          { icon: "📊", title: "Export to CSV" }, { icon: "📋", title: "Copy to Clipboard" }, 
          { icon: "↩️", title: "Reset Layout"}
        ].map(({ icon, title }, i) => (
          <span
            key={i}
            title={title}
            id={`${title}-button`}
            style={{
              fontSize: "22px",
              cursor: "pointer",
              userSelect: "none",
              transition: "transform 0.2s ease"
            }}
            onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
            onClick={() => handleIconClick(title)}
          >
            <Tooltip
                    target="#addAssetTenantButton"
                    showEvent="mouseenter"
                    hideEvent="mouseleave"
                    position="bottom"
                  >
                    <div className="custom-tooltip">Add an Asset</div>
                  </Tooltip>
            {icon}
          </span>
        ))}


          {/* {["✏️", "🖐️", "📊", "📋", "↩️"].map((icon, i) => (
            <span
              key={i}
              style={{
                fontSize: "22px",
                cursor: "pointer",
                userSelect: "none",
                transition: "transform 0.2s ease"
              }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
              onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
              onClick={() => console.log("Clicked", icon)}
            >
              {icon}
            </span>
          ))} */}
        </div>
  
        {/* FLEXLAYOUT AREA */}
        <div style={{ flex: 1, minWidth: 0, position: "relative" }}>
          <Layout model={model} factory={factory} />
        </div>
      </div>
    );
  }

